// extracted by mini-css-extract-plugin
module.exports = {"OASIS-C":"OASIS2_OASIS-C__VUj84"};